import isScrolledIntoView from '@assets/js/isScrolledIntoView.js'

export default function onScrollAnimate() {
  document.querySelectorAll('[data-animate="false"]').forEach(item => {
    if (item && isScrolledIntoView(item) === true) {
      item.dataset.animate = true
      if (item.dataset.delay) {
        let index = 0
        let siblings = document.querySelectorAll('[data-delay="true"]')
        siblings.forEach((item1, i) => {
          if (item == item1) {
            index = i
          }
        })
        let timeOut = 200 * index
        // item.dataset.delay
        setTimeout(() => {
          item.dataset.delay = false
        }, timeOut)
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/scrollAnimate.js